<template>
    <div>
        <div class="search-box">
            <p>学生姓名：</p>
            <a-input class="input-box" v-model="searchFrom.studentName" />
            <p>学生分类：</p>
            <a-select 
                class="input-box" 
                allowClear 
                show-search 
                :filter-option="filterOption"
                 v-model="searchFrom.studentTypeCode">
                <a-select-option v-for="(item,index) in xslbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
            <p>导师姓名：</p>
            <a-input class="input-box" v-model="searchFrom.guideTeacherName" />
            <p>申请类别：</p>
            <a-select 
                class="input-box" 
                allowClear 
                show-search 
                :filter-option="filterOption"
                 v-model="searchFrom.outgoingApplyTypeCode">
                <a-select-option v-for="(item,index) in sqlbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>
            <!-- <a-button type="primary" icon="download" class="right-btn" >导出Excel</a-button> -->
            <!-- <a-button type="primary" icon="import" class="right-btn" >批量导入</a-button> -->
            <a-button type="primary" icon="plus" class="right-btn" @click="$refs.info.showDrawer('新增','')">新增</a-button>
        </div>
        <a-table 
            :columns="columns" 
            :data-source="data" 
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            bordered>
            <template slot="id" slot-scope="text">
                <a class="action-btn" @click="$refs.info.showDrawer('查看',text)">详情</a>
                <a-divider type="vertical" />
                <a class="action-btn" @click="$refs.info.showDrawer('编辑',text)">编辑</a>
                <a-divider type="vertical" />
                <a-popconfirm
                    title="确定删除？"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="remove(text)"
                >
                    <a class="action-btn">删除</a>
                </a-popconfirm>
            </template>
        </a-table>
        <!-- <p class="table-tips">更新截至日期：{{lastTime}}</p> -->
        <info ref="info"></info>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { list,del } from '@/baseAPI/international/outging'
    import Info from './modules/outgingInfo'
    const columns = [
        {
            title: '序号',
            dataIndex: 'id',
            align:'center',
            width:70,
            customRender: (text, row, index) => {
                return { children: index+1};
            },
        },
        {
            title: '学院',
            dataIndex: 'departmentName',
            align:'center',
        },
        {
            title: '学生姓名',
            dataIndex: 'studentName',
            align:'center',
        },
        {
            title: '学号',
            dataIndex: 'studentNo',
            align:'center',
        },
        {
            title: '学生类别',
            dataIndex: 'studentTypeName',
            align:'center'
        },
        {
            title: '导师姓名',
            dataIndex: 'guideTeacherName',
            align:'center'
        },
        {
            title: '项目名称',
            dataIndex: 'projectName',
            align:'center',
            ellipsis: true,
        },
        {
            title: '申请类别',
            dataIndex: 'outgoingApplyTypeName',
            align:'center'
        },
        {
            title: '国家',
            dataIndex: 'abroadCountry',
            align:'center'
        },
        {
            title: '派出时间',
            dataIndex: 'sendDate',
            align:'center'
        },
        {
            title: '拟回国时间',
            dataIndex: 'returnDate',
            align:'center'
        },
        {
            title: '操作',
            dataIndex: 'id',
            width:170,
            scopedSlots: { customRender: 'id' },
        }

    ];
    export default {
        name: 'teacher',
        components: {
            Info
        },
        data () {
            return {
                columns,
                data:[],
                loading: false,
                pagination:{
                    pageSize: 10,
                    current: 0,
                    total:0,
                },
                searchFrom:{
                    size: '',
                    current: '',
                    studentName:'',
                    studentTypeCode:'',
                    guideTeacherName:'',
                    outgoingApplyTypeCode:'',
                },
                xslbArr:[],
                sqlbArr:[],
                lastTime:'',
            }
        },
        mounted () {
            getDicts({dataCode:'XSLB',status:true}).then(res=>{
                this.xslbArr=res.data.dicts;
            })
            getDicts({dataCode:'WCSQLB',status:true}).then(res=>{
                this.sqlbArr=res.data.dicts;
            })
            this.fetch()
        },
        methods:{
            handleTableChange(pagination){
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records;
                    this.loading = false;
                })
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            remove(id){
                del(id).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'删除课程建设项目成功',
                        });
                        this.fetch()
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },

        }
    }
</script>
<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 24px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 13rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .table-tips{
        margin-top: -48px;
        line-height: 32px;
        padding-left: 15px;
        color: #aaa;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }

</style>
